const ErrorMessage = props => <div className='text-red-600 text-sm mt-1'>{props.children}</div>;

export default ErrorMessage;
